import { render, staticRenderFns } from "./LegacyLogin.vue?vue&type=template&id=7abac5eb&scoped=true"
import script from "./LegacyLogin.vue?vue&type=script&lang=js"
export * from "./LegacyLogin.vue?vue&type=script&lang=js"
import style0 from "./LegacyLogin.vue?vue&type=style&index=0&id=7abac5eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abac5eb",
  null
  
)

export default component.exports